import React, { useContext } from 'react';
import { useController } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { StyleSheet, Text, View } from 'react-native';
import { Menu, MenuOption, MenuOptions, MenuTrigger } from 'react-native-popup-menu';
import _fonts from '_fonts';
import { Theme, useThemeStyle, WW } from '_utils';
import { ThemeContext } from '_utils/themeContext';
import { Icon } from 'Components';

interface DropdownSelectorProps {
    items: { id: 'apartment' | 'detached_house' | 'semi_detached_house' | 'room'; name: string }[];
}
const DropdownSelector = ({ items }: DropdownSelectorProps) => {
    const themedStyle = useThemeStyle(styles);
    const { theme } = useContext(ThemeContext);
    const { t } = useTranslation();
    const { field } = useController({ name: 'type' });
    const selectedItem = items.find((item) => item.id === field.value);
    const getOnChangeHandler = (id: string) => () => field.onChange(id);

    return (
        <>
            <Text style={themedStyle.label}>{t('myHome:type')}</Text>
            <Menu>
                <MenuTrigger>
                    <View
                        style={[
                            themedStyle.selected,
                            {
                                borderColor: field.value ? theme.main : theme.secondaryLight,
                            },
                        ]}
                    >
                        <Text style={themedStyle.selectedText}>{selectedItem?.name ?? ''}</Text>
                        <Icon style={themedStyle.chevron} name={'chevron'} color="black" />
                    </View>
                </MenuTrigger>
                <MenuOptions customStyles={{ optionsContainer: themedStyle.menu }}>
                    {items?.map(({ id, name }) => (
                        <MenuOption key={id} onSelect={getOnChangeHandler(id)}>
                            <Text style={themedStyle.menuText}>{name}</Text>
                        </MenuOption>
                    ))}
                </MenuOptions>
            </Menu>
        </>
    );
};

const styles = (theme: Theme) =>
    StyleSheet.create({
        selected: {
            flexDirection: 'row',
            paddingTop: WW * 0.02,
            paddingBottom: WW * 0.02,
            paddingLeft: WW * 0.02,
            paddingRight: WW * 0.02,
            alignItems: 'center',
            borderWidth: 1.5,
            borderRadius: 4,
        },
        selectedText: {
            flex: 1,
            fontFamily: _fonts.primaryFont,
        },
        chevron: { transform: [{ rotate: '90deg' }] },
        label: {
            color: theme.black,
            fontFamily: _fonts.primaryFontBold,
            fontSize: WW * 0.04,
            marginBottom: WW * 0.01,
            marginTop: WW * 0.03,
        },
        menu: {
            width: WW * 0.92,
            marginTop: WW * 0.1,
            backgroundColor: theme.mainBackground,
        },
        menuText: {
            color: theme.black,
            fontFamily: _fonts.primaryFont,
            fontSize: WW * 0.04,
            marginTop: WW * 0.02,
            marginBottom: WW * 0.02,
        },
    });

export default DropdownSelector;
